export default {
  data() {
    return {};
  },
  methods: {
    callToaster(msg) {
      this.$toasted.show(msg, {
        position: "top-center",
        duration: 3500,
        action: [],
        closeOnSwipe: true,
        color: "#9b3c6e",
        className: "notif-class",
      });
    },
  },
};
